import { actionBarAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const actionBarSlotRecipe = defineSlotRecipe({
  slots: actionBarAnatomy.keys(),
  className: 'action-bar',
  base: {
    positioner: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      pointerEvents: 'none',
      insetInline: 0,
      top: 'unset',
      bottom: 'calc(env(safe-area-inset-bottom) + 20px)',
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      boxShadow: 'elevation/lg',
      pointerEvents: 'auto',
      border: '1px solid',
      borderColor: 'border/minimal',
      borderRadius: '8',
      backgroundColor: 'background/primary',
      _open: {
        animationName: 'slide-from-bottom, fade-in',
        animationDuration: 'moderate',
      },

      _closed: {
        animationName: 'slide-to-bottom, fade-out',
        animationDuration: 'faster',
      },
    },
    separator: {
      width: '1',
      height: '24',
      bg: 'border/minimal',
    },
  },
  variants: {
    size: {
      md: {
        content: {
          padding: '12',
          paddingInlineStart: '16',
          gap: '12',
        },
      },
      sm: {
        content: {
          padding: '8',
          paddingInlineStart: '12',
          gap: '8',
        },
      },
      xs: {
        content: {
          padding: '8',
          paddingInlineStart: '12',
          gap: '8',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default actionBarSlotRecipe;
